export const description =
  "Toutes les aides 2026 pour vos investissements agricoles : CEE secteur AGRI, FranceAgriMer, Plan France 2030, PCAE régional (FEADER), aides locales. Conditions, cumuls, démarches.";
